/** Maps repository audience_type slug used by accounts share APIs. */
const getShareAudienceType = (queryType: string) => {
  if (queryType === 'conversation') {
    return 'conversation';
  }
  if (queryType === 'tsv') {
    return 'tsv';
  }
  if (queryType === 'segmentation') {
    return 'segmentation';
  }
  return 'interest';
};

/**
 * ShareAudience + accounts sagas expect a repository item with `metadata.target_query`,
 * not a flat prepareNewAudience payload.
 */
export const toShareAudienceSelectedItem = (
  audience: Record<string, unknown> & { id: string | number }
) => {
  const queryType = String(audience.query_type ?? 'interest');
  const dataSource = audience.data_source as string | undefined;

  return {
    id: audience.id,
    label: audience.label ?? audience.target_label,
    metadata: {
      query_type: queryType,
      audience_type: getShareAudienceType(queryType),
      target_query: audience.target_query,
      base_query: audience.base_query,
      data_source: dataSource,
      source: dataSource,
      target_membership_id: audience.target_membership_id,
      audience_timeframe: audience.audience_timeframe,
      results_timeframe: audience.results_timeframe,
    },
  };
};
